<template>
  <div class="toolContain" style="position: absolute; top: 0; right: 0">
    <tipIcom
      v-if="locale == 'en'"
      iconClass="icon40"
      url="/image/home/Chinese.png"
      :tip="t('Language Switch')"
      @click="languageSwitch"
    ></tipIcom>
    <tipIcom
      v-if="locale == 'zh'"
      iconClass="icon40"
      url="/image/home/English.png"
      :tip="t('Language Switch')"
      @click="languageSwitch"
    ></tipIcom>
    <tipIcom
      iconClass="icon40"
      url="/image/home/assist.png"
      :tip="t('Help')"
    ></tipIcom>
    <tipIcom
      iconClass="icon40"
      url="/image/home/about.png"
      :tip="t('About')"
      @click="showAboutDialog"
    ></tipIcom>
  </div>
  <div class="login">
    <div class="title">
      {{ $t("welcome") }}<br /><el-text class="mx-1" type="primary"
        >iOralCloud</el-text
      >
    </div>
    <el-tabs v-model="activeName" class="login-tabs" @tab-change="changeTabs">
      <!-- 登录 -->
      <el-tab-pane :label="$t('login')" name="login" lazy>
        <el-form
          class="loginForm"
          label-position="right"
          label-width="auto"
          :model="loginForm"
          ref="loginFormRef"
          :rules="loginrules"
        >
          <el-form-item label-position="right" prop="account">
            <el-input
              v-debounce:keyup.enter="{ handler: login, delay: 300 }"
              v-model="loginForm.account"
              :placeholder="$t('Please enter your email address')"
            >
              <template #prefix>
                <img
                  class="userIcon"
                  src="/image/login/user.png"
                  alt="Custom Icon"
                />
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label-position="right" prop="password">
            <el-input
              v-debounce:keyup.enter="{ handler: login, delay: 300 }"
              v-model="loginForm.password"
              :type="loginShowPassword ? 'text' : 'password'"
              :placeholder="$t('Please enter password')"
            >
              <template #prefix>
                <img class="lockIcon" src="/image/login/lock-on.png" />
              </template>
              <template #suffix>
                <img
                  class="eyeOff"
                  v-show="!loginShowPassword"
                  style="cursor: pointer"
                  src="/image/login/eye-off.png"
                  @click="togglePasswordVisibility"
                />
                <img
                  class="eyeOn"
                  v-show="loginShowPassword"
                  style="cursor: pointer"
                  src="/image/login/eye-on.png"
                  @click="togglePasswordVisibility"
                />
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label-position="right">
            <div
              style="
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <el-checkbox
                v-model="savePasswordChecked"
                @change="savePassword"
                >{{ $t("Remember Password") }}</el-checkbox
              >
              <el-button
                link
                type="primary"
                @click="ForgotPasswordDialogShow = !ForgotPasswordDialogShow"
                style="float: right"
              >
                {{ $t("Forgot password") }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label-position="right">
            <el-button
              v-debounce:click="{ handler: login, delay: 300 }"
              class="loginBtn"
              type="primary"
              size="large"
              >{{ $t("login") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 注册 -->
      <el-tab-pane :label="$t('Register New Account')" name="register" lazy>
        <el-form
          class="registerForm"
          ref="registerFormRef"
          label-position="left"
          :model="registerForm"
          :rules="rules"
        >
          <el-form-item label-position="left">
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("Account type")
              }}</span>
              <!-- <span class="required" style="color: #ff0000">*</span> -->
            </template>
            <el-select
              popper-class="accountTypeSelect"
              :teleported="false"
              v-model="registerForm.accountType"
              :placeholder="$t('Please select an account type')"
            >
              <el-option :label="$t('Doctor')" value="0" />
              <el-option :label="$t('laboratory')" value="1" />
            </el-select>
          </el-form-item>

          <el-form-item label-position="left" prop="email">
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("Email")
              }}</span>
              <span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              v-model="registerForm.email"
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              :placeholder="$t('Please enter email')"
            >
            </el-input>
          </el-form-item>

          <el-form-item label-position="left">
            <template #label>
              <span class="custom-label" v-textTootip:auto>
                {{ t("Contact Number") }}</span
              >
            </template>
            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.phone"
              :placeholder="$t('Please Enter Phone Number')"
            >
            </el-input>
          </el-form-item>

          <el-form-item label-position="left" prop="password">
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("Password")
              }}</span>
              <span class="required" style="color: #ff0000">*</span>
            </template>

            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              :type="registerShowPassword ? 'text' : 'password'"
              v-model="registerForm.password"
              :placeholder="$t('Please enter password')"
            >
              <template #suffix>
                <img
                  class="eyeOff"
                  v-show="!registerShowPassword"
                  style="cursor: pointer"
                  src="/image/login/eye-off.png"
                  @click="toggleRegisterPasswordVisibility"
                />
                <img
                  class="eyeOn"
                  v-show="registerShowPassword"
                  style="cursor: pointer"
                  src="/image/login/eye-on.png"
                  @click="toggleRegisterPasswordVisibility"
                />
              </template>
            </el-input>
          </el-form-item>

          <el-form-item
            label-position="left"
            :label="$t('Confirm Password')"
            prop="confirmPassword"
          >
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("Confirm Password")
              }}</span
              ><span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              :type="registerShowConfirmPassword ? 'text' : 'password'"
              v-model="registerForm.confirmPassword"
              :placeholder="$t('Please enter your confirmation password')"
            >
              <template #suffix>
                <img
                  class="eyeOff"
                  v-show="!registerShowConfirmPassword"
                  style="cursor: pointer"
                  src="/image/login/eye-off.png"
                  @click="toggleRegisterConfirmPasswordVisibility"
                />
                <img
                  class="eyeOn"
                  v-show="registerShowConfirmPassword"
                  style="cursor: pointer"
                  src="/image/login/eye-on.png"
                  @click="toggleRegisterConfirmPasswordVisibility"
                />
              </template>
            </el-input>
          </el-form-item>

          <el-form-item
            label-position="left"
            :label="$t('User Name')"
            prop="username"
          >
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("User Name")
              }}</span
              ><span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.username"
              :placeholder="$t('Please enter your username')"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            v-show="registerForm.accountType == 1"
            label-position="left"
            prop="clinicName"
          >
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("laboratory Name")
              }}</span
              ><span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.clinicName"
              :placeholder="$t('Please enter the clinic name')"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            v-show="registerForm.accountType == 0"
            label-position="left"
            prop="clinicName"
          >
            <template #label>
              <span class="custom-label" v-textTootip:auto>{{
                $t("Clinic name")
              }}</span
              ><span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.clinicName"
              :placeholder="$t('Please enter the clinic name')"
            >
            </el-input>
          </el-form-item>

          <el-form-item label-position="left">
            <template #label>
              <span class="custom-label" v-textTootip:auto>
                {{ $t("address") }}</span
              >
            </template>
            <el-input
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.address"
              :placeholder="$t('Please enter the address')"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            v-if="verificationCodeShow"
            label-position="left"
            prop="verificationCode"
          >
            <template #label>
              <span class="custom-label" v-textTootip:auto>
                {{ $t("Verification code") }} </span
              ><span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              class="verificationCodeInput"
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.verificationCode"
              :placeholder="$t('Please enter the verification code')"
            >
            </el-input>
            <img
              class="verificationCodeImage"
              :src="VerifyPicture.imageBase64"
            />
            <img
              class="verificationCodeRefresh"
              @click="getVerifyCode"
              src="/image/home/refresh.png"
            />
          </el-form-item>

          <el-form-item label-position="left" prop="registerCode">
            <template #label>
              <span class="custom-label" v-textTootip:auto>
                {{ $t("Registration Code") }} </span
              ><span class="required" style="color: #ff0000">*</span>
            </template>
            <el-input
              class="registerCodeInput"
              v-debounce:keyup.enter="{ handler: register, delay: 300 }"
              v-model="registerForm.registerCode"
              :placeholder="$t('Please enter the registration code')"
            >
            </el-input>
            <div class="getRegisterCode flexMiddle">
              <span
                v-show="registerCodeState == 0"
                style="color: #6f9c29"
                @click="getRegisterCode"
                >{{ t("Get Code") }}</span
              >
              <span
                v-show="registerCodeState == 1"
                class="countdown-text"
                style="color: #6f9c29"
                >{{ t("Resend")
                }}{{
                  "(" + String(registerCountdown).padStart(2, "0") + ")s"
                }}</span
              >
              <span
                v-show="registerCodeState == 2"
                style="color: #6f9c29"
                @click="getRegisterCode"
                >{{ t("Resend") }}</span
              >
            </div>
          </el-form-item>

          <el-button
            class="registerBtn"
            type="primary"
            size="large"
            v-debounce:click="{ handler: register, delay: 300 }"
            >{{ $t("register") }}</el-button
          >
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
  <!-- 忘记密码 -->
  <el-dialog
    draggable
    class="ForgotPasswordDialog"
    destroy-on-close
    v-model="ForgotPasswordDialogShow"
    :title="t('Recover Password')"
    :modal="false"
    :close-on-click-modal="false"
    @close="ForgotPasswordRef.resetFields()"
  >
    <div class="ForgotPasswordContent">
      <el-form
        class="ForgotPasswordForm"
        ref="ForgotPasswordRef"
        label-position="left"
        :model="ForgotPasswordForm"
        :rules="ForgotPasswordRules"
      >
        <el-form-item prop="email">
          <template #label>
            <span class="custom-label" v-textTootip:auto>{{ $t("Email") }}</span
            ><span class="required" style="color: #ff0000">*</span>
          </template>
          <el-input
            v-debounce:keyup.enter="{
              handler: ForgotPasswordSubmit,
              delay: 300,
            }"
            v-model="ForgotPasswordForm.email"
            :placeholder="$t('Please enter email')"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="registerCode">
          <template #label>
            <span class="custom-label" v-textTootip:auto>
              {{ $t("Registration Code") }} </span
            ><span class="required" style="color: #ff0000">*</span>
          </template>
          <el-input
            class="registerCodeInput"
            v-debounce:keyup.enter="{
              handler: ForgotPasswordSubmit,
              delay: 300,
            }"
            v-model="ForgotPasswordForm.registerCode"
            :placeholder="$t('Please enter the registration code')"
          >
          </el-input>
          <div class="ForgotPasswordCode flexMiddle">
            <span
              v-show="ForgotPasswordCodeState == 0"
              style="color: #6f9c29"
              @click="getForgotPasswordCode"
              >{{ t("Get Code") }}</span
            >
            <span
              v-show="ForgotPasswordCodeState == 1"
              class="countdown-text"
              style="color: #6f9c29"
              >{{ t("Resend")
              }}{{
                "(" + String(ForgotPasswordCountdown).padStart(2, "0") + ")s"
              }}</span
            >
            <span
              v-show="ForgotPasswordCodeState == 2"
              style="color: #6f9c29"
              @click="getForgotPasswordCode"
              >{{ t("Resend") }}</span
            >
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <template #label>
            <span class="custom-label" v-textTootip:auto>{{
              $t("Password")
            }}</span
            ><span class="required" style="color: #ff0000">*</span>
          </template>
          <el-input
            v-debounce:keyup.enter="{
              handler: ForgotPasswordSubmit,
              delay: 300,
            }"
            v-model="ForgotPasswordForm.password"
            :placeholder="$t('Please enter password')"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="confirmPassword">
          <template #label>
            <span class="custom-label" v-textTootip:auto>{{
              $t("Confirm Password")
            }}</span
            ><span class="required" style="color: #ff0000">*</span>
          </template>
          <el-input
            v-debounce:keyup.enter="{
              handler: ForgotPasswordSubmit,
              delay: 300,
            }"
            v-model="ForgotPasswordForm.confirmPassword"
            :placeholder="$t('Please enter your password here')"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <el-row type="flex" align="middle" justify="center">
        <el-button
          class="ForgotPasswordBtn"
          type="primary"
          v-debounce:click="{ handler: ForgotPasswordSubmit, delay: 300 }"
          >{{ t("Confirm") }}</el-button
        >
      </el-row>
    </template>
  </el-dialog>

  <!-- 关于弹窗 -->
  <el-dialog
    v-model="aboutDialogShow"
    :title="t('About')"
    width="400px"
    :close-on-click-modal="false"
    draggable
    :modal="false"
    top="20vh"
    class="aboutDialog"
  >
    <div class="about-content">
      <p class="version-text">
        <span>{{ t("Version") }}: </span>
        <span class="version-number">{{ appVersion }}</span>
      </p>
    </div>
    <template #footer>
      <el-row type="flex" align="middle" justify="center">
        <el-button type="primary" @click="aboutDialogShow = false">
          {{ t("Confirm") }}
        </el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script setup>
import { loginStore, PublicStore } from "@/tools/pinia/store.js";
import instance from "@/tools/axios/index.js";
import { nextTick, reactive } from "vue";
import WebSocketService from "@/utils/websocket.js";
import AES from "@/utils/crypto.js";
let loginStores = loginStore();
let PublicStores = PublicStore();
const { t, locale } = useI18n();

// 关于弹窗
let aboutDialogShow = ref(false);
const appVersion = ref("");
function showAboutDialog() {
  // 从全局配置中获取版本号
  appVersion.value = window.g.Version;
  aboutDialogShow.value = true;
}
// 语言切换
function languageSwitch() {
  if (locale.value == "zh") {
    locale.value = "en";
    PublicStores.changeLanguage(0);
  } else {
    locale.value = "zh";
    PublicStores.changeLanguage(1);
  }
}
// tab选中
const activeName = ref("login");
let VerifyPicture = reactive({});
async function changeTabs(value) {
  if (value == "register") {
    verificationCodeShow.value = true;
    getVerifyCode();
    resetRegisterForm();
    nextTick(() => {
      registerFormRef.value.clearValidate();
    });
  }
}
// 登录密码显示隐藏操作
const loginShowPassword = ref(false);
const togglePasswordVisibility = () => {
  loginShowPassword.value = !loginShowPassword.value;
};
// 注册密码显示隐藏操作
const registerShowPassword = ref(false);
const registerShowConfirmPassword = ref(false);
const toggleRegisterPasswordVisibility = () => {
  registerShowPassword.value = !registerShowPassword.value;
};
const toggleRegisterConfirmPasswordVisibility = () => {
  registerShowConfirmPassword.value = !registerShowConfirmPassword.value;
};
// 获得验证码
async function getVerifyCode() {
  let res = await getRequest("/dental/base/getCaptcha");
  if (res.code == 200) {
    VerifyPicture.ID = res.data.ID;
    VerifyPicture.imageBase64 = res.data.Image;
  }
}
// 登录表单信息
let loginFormRef = ref(null);
const loginForm = reactive({
  account: loginStores.account || "",
  password: AES.decrypt(loginStores.password) || "",
});
const verifyAccount = (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("The email address cannot be empty")));
  } else {
    callback();
  }
};
const verifyPassword = (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("The password cannot be empty")));
  } else {
    callback();
  }
};
const loginrules = reactive({
  account: [{ validator: verifyAccount, trigger: "blur" }],
  password: [{ validator: verifyPassword, trigger: "blur" }],
});

// 密码保存勾选
let savePasswordChecked = ref(loginStores.getSavePasswordChecked);
function savePassword(value) {
  // 无论是否勾选，都保存账号信息
  loginStores.changeAccount(loginForm.account);

  if (value) {
    loginStores.changePassword(AES.encrypt(loginForm.password));
  } else {
    loginStores.changePassword("");
  }
  loginStores.changeSavePasswordChecked(value);
}

const router = useRouter();
async function login() {
  loginFormRef.value.validate(async (valid) => {
    if (!valid) {
      return;
    }
    let data = {
      Email: loginForm.account,
      Password: loginForm.password,
    };
    try {
      let res = await postRequest("/dental/base/login", data);

      // 网络错误：res 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
      if (
        !res ||
        res.name === "AxiosError" ||
        (typeof res.code === "string" && res.code.startsWith("ERR_"))
      ) {
        ElMessageBox({
          title: t("Prompt"),
          message: h("p", null, [
            h("span", null, t("Network error, login failed. Please try again")),
          ]),
          showCancelButton: false,
          confirmButtonText: t("Yes"),
          customClass: "ErrorMessageBox",
          confirmButtonClass: "confirm-button-with-icon",
          modal: false,
          draggable: true,
          overflow: false,
        }).then(() => {});
        return;
      }

      if (res.code == 200) {
        PublicStores.changeAccessToken(res.data.AccessToken);
        PublicStores.changeRefreshToken(res.data.RefreshToken);
        PublicStores.changeUserInfo(res.data.UserInfo);
        // 设置axios请求头携带
        instance.defaults.headers["AccessToken"] = res.data.AccessToken;
        instance.defaults.headers["RefreshToken"] = res.data.RefreshToken;
        // 无论是否勾选记住密码，都保存账号信息
        loginStores.changeAccount(loginForm.account);

        if (savePasswordChecked.value) {
          loginStores.changePassword(AES.encrypt(loginForm.password));
        } else {
          loginStores.changePassword("");
        }
        PublicStores.changeWebSocketService();
        PublicStores.WebSocketService.connect();
        // websocketService.connect();
        // websocketService.addListener(handleMessage);
        router.push("/home");
        ElMessage({
          message: res.message,
          type: "success",
        });
        return;
      }
      // ElMessage({
      //   message: t("Login failure"),
      //   type: "error",
      // });
      const errorMessage = res.message || t("Login failure");
      ElMessageBox({
        title: t("Prompt"),
        message: h("p", null, [h("span", null, errorMessage)]),
        showCancelButton: false,
        confirmButtonText: t("Yes"),
        customClass: "ErrorMessageBox",
        confirmButtonClass: "confirm-button-with-icon",
        modal: false,
        draggable: true,
        overflow: false,
      }).then(() => {});
    } catch (error) {
      // 捕获网络错误
      ElMessageBox({
        title: t("Prompt"),
        message: h("p", null, [
          h("span", null, t("Network error, login failed. Please try again")),
        ]),
        showCancelButton: false,
        confirmButtonText: t("Yes"),
        customClass: "ErrorMessageBox",
        confirmButtonClass: "confirm-button-with-icon",
        modal: false,
        draggable: true,
        overflow: false,
      }).then(() => {});
    }
  });
}

// 注册表单
const registerFormRef = ref(null);
const registerForm = reactive({
  accountType: "0",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  username: "",
  clinicName: "",
  address: "",
  verificationCode: "",
  registerCode: "",
});
const verifyEmail = (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("Please enter your email address")));
  } else if (value.length > 64) {
    callback(new Error(t("Email address cannot exceed 64 characters")));
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      callback(new Error(t("Please input a valid email address")));
    } else {
      callback();
    }
  }
};
const verifyPass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(t("Please enter password")));
  } else {
    callback();
  }
};
const verifyConfirmPass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(t("Please enter your password here")));
  } else if (value !== registerForm.password) {
    callback(new Error(t("The two passwords are inconsistent")));
  } else {
    callback();
  }
};
const verifyUsername = (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("Please enter your username")));
  } else {
    callback();
  }
};
const verifyClinicName = (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("Please enter the clinic name")));
  } else {
    callback();
  }
};
let verificationCodeShow = ref(true);

const verifyCode = async (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("Please enter the verification code")));
  } else {
    try {
      let codedata = {
        ID: VerifyPicture.ID,
        Answer: registerForm.verificationCode,
      };
      let result = await postRequest("/dental/base/verifyCaptcha", codedata);

      // 网络错误：result 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
      if (
        !result ||
        result.name === "AxiosError" ||
        (typeof result.code === "string" && result.code.startsWith("ERR_"))
      ) {
        callback(
          new Error(t("Network error, verification failed. Please try again"))
        );
        return;
      }

      // 业务错误（验证码错误）
      if (result.code != 200) {
        getVerifyCode();
        registerForm.verificationCode = "";
        callback(new Error(result.message || t("Invalid Code")));
        return;
      }

      // 验证成功
      verificationCodeShow.value = false;
      callback();
      // 验证码正确后，自动发送注册码
      if (registerCodeState.value === 0 && registerForm.email) {
        await sendRegisterCode();
      }
    } catch (error) {
      // 捕获网络错误
      callback(
        new Error(t("Network error, verification failed. Please try again"))
      );
    }
  }
};
const verifyregisterCode = (rule, value, callback) => {
  if (value == "") {
    callback(new Error(t("Please enter the registration code")));
  } else {
    callback();
  }
};
// 注册表规则校验
const rules = reactive({
  email: [{ validator: verifyEmail, trigger: "blur" }],
  password: [{ validator: verifyPass, trigger: "blur" }],
  confirmPassword: [{ validator: verifyConfirmPass, trigger: "blur" }],
  username: [{ validator: verifyUsername, trigger: "blur" }],
  clinicName: [{ validator: verifyClinicName, trigger: "blur" }],
  verificationCode: [{ validator: verifyCode, trigger: "blur" }],
  registerCode: [{ validator: verifyregisterCode, trigger: "blur" }],
});
// 获取时区
// const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
// 获取注册码
let registerCodeState = ref(0);
let registerCountdown = ref(60);
let timer = null;
// 发送注册码的核心逻辑
async function sendRegisterCode() {
  if (registerCodeState.value === 1) return; // 倒计时中不允许重复发送
  if (!registerForm.email) return; // 没有email不发送

  try {
    let res = await postRequest("/dental/base/sendActivationEmail", {
      CaptchaID: VerifyPicture.ID,
      Email: registerForm.email,
      Type: "register",
    });

    // 网络错误：res 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
    if (
      !res ||
      res.name === "AxiosError" ||
      (typeof res.code === "string" && res.code.startsWith("ERR_"))
    ) {
      ElMessage({
        message: t("Network error, please check your network connection"),
        type: "error",
      });
      registerCodeState.value = 2;
      return;
    }

    if (res.code != 200 && res.code != 10016) {
      ElMessage({
        message: res.message,
        type: "error",
      });
      registerCodeState.value = 2;
      return;
    }

    if (res.code == 10016) {
      ElMessage({
        message: res.message,
        type: "error",
      });
    }

    if (registerCodeState.value === 0 || registerCodeState.value === 2) {
      registerCodeState.value = 1;
      registerCountdown.value = 60;
      if (timer) clearInterval(timer);
      timer = setInterval(() => {
        if (registerCountdown.value > 0) {
          registerCountdown.value--;
        } else {
          clearInterval(timer);
          registerCodeState.value = 2;
        }
      }, 1000);
    }
  } catch (error) {
    // 捕获网络错误
    ElMessage({
      message: t("Network error, please check your network connection"),
      type: "error",
    });
    registerCodeState.value = 2;
  }
}
// 手动获取注册码（用户点击按钮时）
function getRegisterCode() {
  if (registerCodeState.value === 1) return; // 倒计时中不允许重复发送
  registerFormRef.value.validateField("email", async (valid) => {
    if (valid) {
      await sendRegisterCode();
    }
  });
}
// 注册按钮逻辑处理
async function register() {
  registerFormRef.value.validate(async (valid) => {
    if (!valid) {
      return;
    }
    try {
      let result = await postRequest("/dental/base/validateActivationEmail", {
        EmailActivationCode: registerForm.registerCode,
        Email: registerForm.email,
      });

      // 网络错误：result 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
      if (
        !result ||
        result.name === "AxiosError" ||
        (typeof result.code === "string" && result.code.startsWith("ERR_"))
      ) {
        ElMessage({
          message: t("Network error, please check your network connection"),
          type: "error",
        });
        return;
      }

      if (result.code != 200) {
        ElMessage({
          message: result.message,
          type: "error",
        });
        return;
      }

      let data = {
        UserType: registerForm.accountType,
        Email: registerForm.email,
        Phone: registerForm.phone,
        Password: registerForm.password,
        NickName: registerForm.username,
        // TimeZone: userTimeZone,
        EmailActivationCode: registerForm.registerCode,
        Addr: registerForm.address,
        AddrName: registerForm.clinicName,
      };

      let res = await postRequest("/dental/base/register", data);
      // 网络错误：res 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
      if (
        !res ||
        res.name === "AxiosError" ||
        (typeof res.code === "string" && res.code.startsWith("ERR_"))
      ) {
        ElMessage({
          message: t("Network error, please check your network connection"),
          type: "error",
        });
        getVerifyCode();
        registerForm.verificationCode = "";
        return;
      }

      if (res.code == 200) {
        ElMessage({
          message: res.message,
          type: "success",
        });
        resetRegisterForm();
        return;
      }
      ElMessage({
        message: res.message,
        type: "error",
      });
      getVerifyCode();
      registerForm.verificationCode = "";
    } catch (error) {
      // 捕获网络错误
      ElMessage({
        message: t("Network error, please check your network connection"),
        type: "error",
      });
    }
  });
}
function resetRegisterForm() {
  registerForm.accountType = "0";
  registerForm.email = "";
  registerForm.phone = "";
  registerForm.password = "";
  registerForm.confirmPassword = "";
  registerForm.username = "";
  registerForm.clinicName = "";
  registerForm.address = "";
  registerForm.verificationCode = "";
  registerForm.registerCode = "";
}
// 忘记密码的dialog框
const verifyForgotPasswordConfirmPass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(t("Please enter your password here")));
  } else if (value !== ForgotPasswordForm.password) {
    callback(new Error(t("The two passwords are inconsistent")));
  } else {
    callback();
  }
};
const ForgotPasswordRules = reactive({
  email: [{ validator: verifyEmail, trigger: "blur" }],
  registerCode: [{ validator: verifyregisterCode, trigger: "blur" }],
  password: [{ validator: verifyPass, trigger: "blur" }],
  confirmPassword: [
    { validator: verifyForgotPasswordConfirmPass, trigger: "blur" },
  ],
});
let ForgotPasswordDialogShow = ref(false);
let ForgotPasswordCodeState = ref(0);
let ForgotPasswordCountdown = ref(60);
let ForgotPasswordRef = ref(null);
let ForgotPasswordForm = reactive({
  email: "",
  registerCode: "",
  password: "",
  confirmPassword: "",
});
function getForgotPasswordCode() {
  ForgotPasswordRef.value.validateField("email", async (valid) => {
    if (valid) {
      try {
        let res = await postRequest("/dental/base/sendActivationEmail", {
          Email: ForgotPasswordForm.email,
          Type: "forgotPassword",
        });

        // 网络错误：res 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
        if (
          !res ||
          res.name === "AxiosError" ||
          (typeof res.code === "string" && res.code.startsWith("ERR_"))
        ) {
          ElMessage({
            message: t("Network error, please check your network connection"),
            type: "error",
          });
          ForgotPasswordCodeState.value = 2;
          return;
        }

        if (res.code != 200 && res.code != 10016) {
          ElMessage({
            message: res.message,
            type: "error",
          });
          ForgotPasswordCodeState.value = 2; // 倒计时结束，显示"重发注册码"
          return; // 请求失败时直接返回，不开始倒计时
        }

        // 只在特定错误码时显示提示消息
        if (res.code == 10016) {
          ElMessage({
            message: res.message,
            type: "error",
          });
        }

        // 当请求成功(code=200)或特定错误码(code=10017)时开始倒计时
        if (
          ForgotPasswordCodeState.value === 0 ||
          ForgotPasswordCodeState.value === 2
        ) {
          ForgotPasswordCodeState.value = 1; // 开始倒计时
          ForgotPasswordCountdown.value = 60;

          timer = setInterval(() => {
            if (ForgotPasswordCountdown.value > 0) {
              ForgotPasswordCountdown.value--;
            } else {
              clearInterval(timer);
              ForgotPasswordCodeState.value = 2; // 倒计时结束，显示"重发注册码"
            }
          }, 1000);
        }
      } catch (error) {
        // 捕获网络错误
        ElMessage({
          message: t("Network error, please check your network connection"),
          type: "error",
        });
        ForgotPasswordCodeState.value = 2;
      }
    }
  });
}
function ForgotPasswordSubmit() {
  ForgotPasswordRef.value.validate(async (valid) => {
    if (valid) {
      try {
        let data = {
          EmailActivationCode: ForgotPasswordForm.registerCode,
          Email: ForgotPasswordForm.email,
          Password: ForgotPasswordForm.password,
        };
        let res = await postRequest("/dental/base/resetPassword", data);

        // 网络错误：res 为空、是 AxiosError 对象、或者 code 是字符串（ERR_NETWORK 等）
        if (
          !res ||
          res.name === "AxiosError" ||
          (typeof res.code === "string" && res.code.startsWith("ERR_"))
        ) {
          ElMessage({
            message: t("Network error, please check your network connection"),
            type: "error",
          });
          return;
        }

        if (res.code != 200) {
          ElMessage.error(res.message);
          return;
        }
        ElMessage.success(res.message);
        ForgotPasswordDialogShow.value = false;
      } catch (error) {
        // 捕获网络错误
        ElMessage({
          message: t("Network error, please check your network connection"),
          type: "error",
        });
      }
    }
  });
}
</script>
<style lang="scss">
.ErrorMessageBox {
  padding: 0;
  width: 400px;
  height: 240px;
  box-shadow: 4px 4px 16px 0px #13141540;
  display: flex;
  flex-direction: column;
  .el-message-box__header {
    padding: 14px 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccd0d5;
    font-weight: 700;

    .el-message-box__title ::before {
      width: 20px;
      height: 20px;
      content: url("/image/home/warn.png"); /* 替换为图标的路径 */
      margin-right: 16px; /* 添加与文本的间隔 */
      vertical-align: middle;
    }
    .el-message-box__headerbtn {
      display: none;
    }
  }
  .el-message-box__container {
    padding: 18px 32px;
    font-size: 18px;
    line-height: 27px;
  }
  .el-message-box__btns {
    flex-grow: 1;
    align-items: end;
    padding-bottom: 24px;
    padding-right: 24px;
  }
  .cancel-button-with-icon {
    width: 96px;
    height: 48px;
    background: #f3f4f7;
  }
  .cancel-button-with-icon ::before {
    width: 32px;
    height: 32px;
    background: url("/image/home/Close .png"); /* 替换为图标的路径 */
    background-size: 32px;
    margin-right: 8px; /* 添加与文本的间隔 */
    content: "";
  }
  .confirm-button-with-icon {
    width: 96px;
    height: 48px;
    background: #6f9c29;
  }
  .confirm-button-with-icon ::before {
    width: 32px;
    height: 32px;
    background: url("/image/home/Confirm.png"); /* 替换为图标的路径 */
    background-size: 32px;
    margin-right: 8px; /* 添加与文本的间隔 */
    content: "";
  }
}
.accountTypeSelect {
  top: 44px !important;
  left: 0 !important;
  .el-popper__arrow {
    display: none;
  }
  .el-select-dropdown__list {
    padding-top: 0;
    padding-bottom: 0;
  }
  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
  }
  .is-selected {
    background: #d9e7ba;
    color: #494c4f;
    font-family: Source Han Sans CN;
    font-size: 16px;
    font-weight: 400;
  }
}
// 忘记密码dialog
.ForgotPasswordDialog {
  width: 640px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid #ccd0d5;
  box-shadow: 4px 4px 16px 0px #13141540;
  .el-dialog__header {
    margin-right: 0px;
    height: 64px;
    padding: 0px;
    border-bottom: 1px solid #ccd0d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .el-dialog__title {
      margin-left: 72px;
      font-size: 20px;
      font-weight: 700;
    }
    .el-dialog__headerbtn {
      width: 40px;
      height: 40px;
      position: static !important; /* 强制取消绝对定位 */
      margin-top: 12px;
      margin-right: 40px;
      color: #000;
      background: url("/image/home/accountClose.png");
      background-size: cover;
      i {
        display: none; // 在这里隐藏弹窗默认的关闭图标
      }
    }
  }
  .ForgotPasswordContent {
    width: 100%;
    padding: 40px 64px 0;
    box-sizing: border-box;
    .el-form-item {
      margin-bottom: 20px;
    }
  }
  .el-dialog__footer {
    height: 136px;
    .ForgotPasswordBtn {
      width: 200px;
      height: 48px;
    }
  }
}
.ForgotPasswordForm {
  .el-form-item__label {
    width: 108px;
    height: 40px;
    line-height: 40px;
  }
  .registerCodeInput {
    width: 300px;
  }
  .ForgotPasswordCode {
    width: 100px;
    cursor: pointer;
    .countdown-text {
      display: inline-block;
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
      min-width: 80px;
    }
  }
  .el-input {
    height: 40px;
  }
}

// 关于弹窗
.aboutDialog {
  padding: 0;
  border-radius: 8px;
  border: 1px solid #ccd0d5;
  box-shadow: 4px 4px 16px 0px #13141540;
  .el-dialog__header {
    margin-right: 0px;
    height: 64px;
    padding: 0px;
    border-bottom: 1px solid #ccd0d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .el-dialog__title {
      margin-left: 64px;
      font-size: 20px;
      font-weight: 700;
    }
  }
  .el-dialog__body {
    padding: 48px 64px 0 64px;
    .about-content {
      .version-text {
        font-size: 16px;
        line-height: 24px;
        .version-number {
          font-weight: 600;
          color: #6f9c29;
        }
      }
    }
  }
  .el-dialog__footer {
    height: 136px;
    .el-button {
      width: 200px;
      height: 48px;
    }
  }
}
</style>
<style scoped lang="scss">
.login {
  width: 800px;
  height: 100%;
  padding: 80px 196px;
  box-sizing: border-box;
  background: #f6f8fa;
  float: right;
  .title {
    width: 100%;
    height: 100px;
    background: #f6f8fa;
    font-size: 24px;
    font-weight: 500;
    line-height: 38.4px;
    letter-spacing: 0.05em;
    text-align: left;
    .el-text {
      font-size: 36px;
      font-weight: 700;
      line-height: 57.6px;
      letter-spacing: 0.05em;
      text-align: left;
    }
  }
  :deep(.login-tabs) {
    margin-top: 20px;
  }
  :deep(.el-tabs__header) {
    .el-tabs__nav {
      height: 56px;
    }
    .el-tabs__item {
      height: 56px;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      // padding: 0 36px;
    }
    .el-tabs__active-bar {
      height: 4px;
    }
  }
  .loginForm {
    .el-form-item {
      margin-bottom: 40px;
      :deep(.el-checkbox__inner) {
        //大小
        width: 24px;
        height: 24px;
        border-radius: 2px;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner::after) {
        //对钩的位置
        top: 4px;
        left: 9px;
        height: 9px;
        width: 4px;
        border-width: 2px;
      }
      .userIcon,
      .lockIcon {
        width: 18px;
        height: 18px;
      }
      .eyeOff,
      .eyeOn {
        width: 32px;
        height: 32px;
      }
    }
    .el-form-item:nth-child(3) {
      margin-bottom: 67px;
    }
    .el-form-item:nth-child(1) {
      margin-top: 45px;
    }
    .el-input {
      height: 56px;
      :deep(.el-input__prefix-inner) {
        padding-right: 10px;
        padding-left: 7px;
      }
    }
    .loginBtn {
      width: 100%;
      height: 64px;
    }
  }
  .registerForm {
    .el-form-item {
      margin-bottom: 20px;
      :deep(.el-form-item__label) {
        width: 108px;
        font-weight: 1000;
        color: #494c4f;
        height: 40px;
        line-height: 40px;
      }
      .eyeOff,
      .eyeOn {
        width: 32px;
        height: 32px;
      }
      .verificationCodeInput {
        width: 180px;
      }
      .verificationCodeImage {
        width: 80px;
        height: 40px;
        margin-left: 8px;
      }
      .verificationCodeRefresh {
        width: 32px;
        height: 32px;
      }
      .registerCodeInput {
        width: 180px;
      }
      .getRegisterCode {
        width: 120px;
        height: 100%;
        cursor: pointer;
        .countdown-text {
          display: inline-block;
          font-variant-numeric: tabular-nums;
          font-feature-settings: "tnum";
          min-width: 100px;
        }
      }
      .el-input {
        height: 40px;
      }
      :deep(.el-select__wrapper) {
        height: 40px !important;
      }
    }
    .el-form-item:nth-child(1) {
      margin-top: 17px;
    }
    .registerBtn {
      width: 100%;
      height: 64px;
    }
  }
}
</style>
